import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  getHomsFallbackPath,
  isHomsPathEnabled,
} from "../utilities/homsModuleConfigurationUtils";

/**
 * Blocks HOMS routes whose module/page is turned off in company module config.
 */
const HomsModuleGate = ({ children }) => {
  const location = useLocation();
  const modules = useSelector((state) => state.moduleConfigState?.modules);
  const pages = useSelector((state) => state.moduleConfigState?.pages);

  if (!isHomsPathEnabled(location.pathname, modules, pages)) {
    return <Redirect to={getHomsFallbackPath(modules)} />;
  }

  return children;
};

export default HomsModuleGate;
